const GetEOPDCenterStatusName = (id) => {
    switch (id) {
        case 0: { return "Active" }
        case 1: { return "Deactive" }
        case 3: { return "Closed" }

    }
}

const GetEOPDCenterStatus = {
    EOPDCenterStatusName: [
        { Id: 0, Name: "Active" },
        { Id: 1, Name: "Deactive" },
        { Id: 3, Name: "Closed" },

    ]
}

const EOPDCenterStatusBg = (id) => {
    switch (id) {
        case 1: return "bg-red-400"
        case 0: return "bg-green-400"
        case 3: return "bg-orange-400"
    }
}
export { GetEOPDCenterStatusName, GetEOPDCenterStatus, EOPDCenterStatusBg }
